var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function BlockCircleIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM18.3199 7.09436C19.3729 8.44904 20 10.1513 20 12C20 16.4183 16.4183 20 12 20C10.1513 20 8.44904 19.3729 7.09436 18.3199L18.3199 7.09436ZM12 4C13.8487 4 15.551 4.62708 16.9056 5.68014L5.68014 16.9056C4.62708 15.551 4 13.8487 4 12C4 7.58172 7.58172 4 12 4Z", fill: "" })));
}
export var BlockCircleIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: BlockCircleIconInner }, props))); };
//# sourceMappingURL=BlockCircleIcon.js.map